export default __webpack_public_path__ + "static/media/experience_balnk.b2af7c19.svg";